module.exports = __webpack_public_path__ + "static/media/conversionUnsuccesful.ad52ded1.svg";